import { Editor } from "grapesjs";

declare global {
  interface Window {
    // Written into every saved page by consentCore.js; absent in the editor canvas.
    talentechConsent?: { formUrl: (url: string) => string };
  }
}

export const JOB_AD_FIELDS = [
  {
    field: "location",
    label: "Location",
    icon: '<i class="fs-2 fa-sharp fa-light fa-location-dot"></i>',
  },
  {
    field: "job_id",
    label: "Job ID",
    icon: '<i class="fs-2 fa-sharp fa-light fa-hashtag"></i>',
  },
  {
    field: "department",
    label: "Department",
    icon: '<i class="fs-2 fa-sharp fa-light fa-building"></i>',
  },
  {
    field: "title",
    label: "Title",
    icon: '<i class="fa-sharp fa-light fa-block-quote fs-2"></i>',
  },
  {
    field: "ad_text",
    label: "Ad Text",
    icon: '<i class="fs-2 fa-sharp fa-light fa-ad"></i>',
  },
  {
    field: "apply_url",
    label: "Apply URL",
    icon: '<i class="fa-sharp fa-light fa-pen-field fs-2"></i>',
  },
  {
    field: "category",
    label: "Category",
    icon: '<i class="fa-sharp fa-light fa-tag fs-2"></i>',
  },
  {
    field: "application_deadline",
    label: "Application Deadline",
    icon: '<i class="fa-sharp fa-light fa-clock fs-2"></i>',
  },
  {
    field: "contact_persons",
    label: "Contact persons",
    icon: '<i class="fa-sharp fa-light fa-address-book fs-2"></i>',
  },
  {
    field: "salary_range",
    label: "Salary Range",
    icon: '<i class="fa-sharp fa-light fa-sack-dollar fs-2"></i>',
  },
  {
    field: "job_type",
    label: "Job Type",
    icon: '<i class="fa-sharp fa-light fa-briefcase fs-2"></i>',
  },
  {
    field: "workplace_type",
    label: "Workplace Type",
    icon: '<i class="fa-sharp fa-light fa-laptop-house fs-2"></i>',
  }
];

export const JOB_AD_IMAGE_FIELDS = [
  {
    field: "banner_url",
    attribute: "data-banner-url",
    label: "Banner (from ATS)",
    name: "Banner (from ATS)",
    icon: '<i class="fa-sharp fa-light fa-panorama fs-2"></i>',
    style: {
      width: "100%",
      "aspect-ratio": "3 / 1",
      "object-fit": "cover",
    },
  },
  {
    field: "logo_url",
    attribute: "data-logo-url",
    label: "Logo (from ATS)",
    name: "Logo (from ATS)",
    icon: '<i class="fa-sharp fa-light fa-copyright fs-2"></i>',
    style: {
      "max-height": "80px",
      "object-fit": "contain",
    },
  },
];

export function jodAdFields(editor: Editor) {
  JOB_AD_FIELDS.forEach((c) => {
    editor.DomComponents.addType(c.field, {
      model: {
        defaults: {
          type: "textnode",
        },
      },
    });

    editor.Blocks.add(c.field, {
      label: c.label,
      category: "Job Ad",
      media: c.icon,
      content: {
        type: c.field,
        content: `{${c.field.toUpperCase()}}`,
      },
    });
  });

  JOB_AD_IMAGE_FIELDS.forEach((c) => {
    editor.Blocks.add(c.field, {
      label: c.label,
      category: "Job Ad",
      media: c.icon,
      content: {
        type: "image",
        name: c.name,
        attributes: {
          alt: "",
          [c.attribute]: `{${c.field.toUpperCase()}}`,
        },
        style: c.style,
      },
    });
  });

  editor.DomComponents.addType("application-form", {
    model: {
      defaults: {
        script: function () {
          const id = `${this.id}`;
          const iframeWrapper = document.getElementById(
            id
          ) as HTMLDivElement;

          const formIframe = iframeWrapper?.querySelector("iframe") as HTMLIFrameElement | null;
          if (!formIframe) return;
          // Blocks added before data-url existed keep the URL in src.
          const formUrl =
            formIframe.getAttribute("data-url") || formIframe.getAttribute("src") || "";
          formIframe.setAttribute("data-tt-ats-form", "");
          let decidedUrl = "";
          if (window.talentechConsent) {
            decidedUrl = window.talentechConsent.formUrl(formUrl);
          } else {
            try {
              const noTracking = new URL(formUrl);
              if (noTracking.protocol === "https:" || noTracking.protocol === "http:") {
                noTracking.searchParams.set("notrack", "1");
                decidedUrl = noTracking.toString();
              }
            } catch (error) {
              console.error("Invalid URL:", formUrl);
            }
          }
          if (decidedUrl) {
            formIframe.src = decidedUrl;
          }

          window.addEventListener(
            "message",
            function (event) {
              const expectedOrigins = ["https://web103.reachmee.com", 'https://candidate.hr-manager.net'];

              if (!iframeWrapper) {
                console.error("Iframe wrapper not found");
                return;
              }
              const iframe = iframeWrapper.querySelector(
                "iframe"
              ) as HTMLIFrameElement;
              if (
                expectedOrigins.includes(event.origin) &&
                typeof event.data === "string" &&
                event.data.startsWith("resize::")
              ) {
                if (event.source === iframe.contentWindow) {
                  const height = event.data.split("resize::")[1];
                  if (height && iframe) {
                    if (iframe.getAttribute("data-height") !== height) {
                      iframe.style.height = height + "px";
                      iframe.setAttribute("data-height", height);
                    }
                  }
                }
              }
            },
            false
          );
        },
      },
    },
  });

  editor.Blocks.add("application-fomr", {
    label: "Application Form",
    category: "Job Ad",
    media: '<i class="fs-2 fa-sharp fa-light fa-browser"></i>',
    content: {
      components: [
        {
          tagName: "iframe",
          attributes: {
            id: "applicationFormIframe",
            width: "100%",
            frameborder: "0",
            scrolling: "no",
            "data-url": "{APPLY_URL}",
          },
        },
      ],
      type: "application-form",
    },
  });
}
